// Firebase configuration for v8
import firebase from 'firebase/app';
import 'firebase/messaging';
import Config from '../../../Utility/Config';
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCQFFI5gUTTpgNJFI7yAtisomeWM3NSpk0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "waliner-notification.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "waliner-notification",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "waliner-notification.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "193200971189",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:193200971189:web:2724b09c5df9ba750bcdfc",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-80N39EMSQC"
};

// Initialize Firebase with compat API
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
// Initialize messaging with service worker registration
let messaging;

// Initialize service worker and messaging
const initializeServiceWorkerAndMessaging = async () => {
  try {
    // Register service worker first
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      console.log('Service worker registered with scope:', registration.scope);
      
      // Wait for service worker to be ready
      await navigator.serviceWorker.ready;
      console.log('Service worker is ready');
    }
    
    // Initialize Firebase messaging and let it handle service worker detection automatically
    messaging = firebase.messaging();
    console.log('Firebase messaging initialized (auto service worker detection)');
    
    return messaging;
  } catch (error) {
    console.error('Error setting up Firebase messaging:', error);
    // Fallback to initialize messaging without service worker
    console.log('Falling back to messaging without service worker');
    messaging = firebase.messaging();
    return messaging;
  }
};

// Start the initialization process
initializeServiceWorkerAndMessaging();

// Ensure messaging is initialized
const ensureMessaging = () => {
  return new Promise((resolve) => {
    // Check if messaging is already initialized
    if (messaging) {
      resolve(messaging);
      return;
    }

    // If not initialized, wait for service worker registration
    const checkInterval = setInterval(() => {
      if (messaging) {
        clearInterval(checkInterval);
        resolve(messaging);
      }
    }, 100);

    // Timeout after 5 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
      // If messaging is still not initialized, create it without service worker
      if (!messaging) {
        console.warn('Timed out waiting for service worker registration, initializing messaging without service worker');
        messaging = firebase.messaging();
        resolve(messaging);
      }
    }, 5000);
  });
};

// Request permission function
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      // Ensure messaging is initialized
      const messagingInstance = await ensureMessaging();
      
      // Simple approach: wait for service worker and get token
      if ('serviceWorker' in navigator) {
        console.log('Ensuring service worker is ready...');
        await navigator.serviceWorker.ready;
        console.log('Service worker ready, proceeding with token generation');
      }
      
      // Get FCM token directly
      try {
        console.log('Attempting to get FCM token...');
        const currentToken = await messagingInstance.getToken({
          vapidKey: Config.REACT_APP_FIREBASE_VAPID_KEY
        });
        
        if (currentToken) {
          console.log('✅ FCM token acquired successfully:', currentToken.substring(0, 20) + '...');
          return currentToken;
        } else {
          console.log('No FCM token available - this might be normal if notifications are disabled');
          return null;
        }
      } catch (error) {
        console.error('❌ Token generation failed:', error);
        
        // Try without VAPID key as fallback
        console.log('🔄 Retrying without VAPID key...');
        try {
          const tokenWithoutVapid = await messagingInstance.getToken();
          if (tokenWithoutVapid) {
            console.log('✅ FCM token acquired without VAPID key:', tokenWithoutVapid.substring(0, 20) + '...');
            return tokenWithoutVapid;
          }
        } catch (fallbackError) {
          console.error('❌ Token generation failed even without VAPID key:', fallbackError);
        }
        
        throw error;
      }
    } else {
      console.log('Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('Error getting notification permission:', error);
    return null;
  }
};

// Listen for messages function
export const onMessageListener = async () => {
  try {
    // Ensure messaging is initialized before setting up listener
    const messagingInstance = await ensureMessaging();
    
    return new Promise((resolve) => {
      messagingInstance.onMessage((payload) => {
        resolve(payload);
      });
    });
  } catch (error) {
    console.error('Error setting up message listener:', error);
    return Promise.reject(error);
  }
};

export default firebase;
